export const GenericValidationError = ({ allRequired = false }) => (
    <div className="r-my-4 r-border-l-[.375rem] r-border-danger r-bg-gray-100 r-p-4 r-shadow-sm">
        <p>
            Vänligen kontrollera alla fält.{' '}
            {allRequired ? (
                <>Samtliga fält är obligatoriska.</>
            ) : (
                <>
                    <strong>*</strong> Indikera att fältet är obligatoriskt.
                </>
            )}
        </p>
    </div>
);
